import { isValid, parseISO } from 'date-fns';

export const isDateString = (value: string) => {
  if (!value) return false;

  const parsedDate = parseISO(value);

  return isValid(parsedDate);
};
